import createReactComponent from '../createReactComponent';
export default createReactComponent('layers-three', 'LayersThree', [["path",{"d":"m21 12-9 4-9-4m18 4-9 4-9-4m18-8-9 4-9-4 9-4z","key":"svg-0"}]]);